export const ClvrPrimaryBackgroundColor = '#E3EDF5'
export const ClvrPrimaryColor = '#2971B3'
export const ClvrDarkenColor = '#1D4F7E'

export const ClvrLegacyPrimaryColor = '#3F51B5'
